// src/tiles/PrimaryScorePill.jsx
import React from 'react';
import { Chip, Tooltip } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

const tones = {
  green: { borderColor: 'success.main', color: 'success.main' },
  red:   { borderColor: 'error.main',   color: 'error.main' },
};

export default function PrimaryScorePill({ label, value, infoTooltip, tone = 'green' }) {
  const sx = {
    borderWidth: 2,
    borderStyle: 'solid',
    ...tones[tone],
    fontWeight: 600,
  };
  const chip = (
    <Chip
      size="medium"
      variant="outlined"
      icon={infoTooltip ? <InfoOutlinedIcon /> : undefined}
      label={`${label}: ${typeof value === 'number' ? value.toFixed(0) : value}`}
      sx={sx}
    />
  );
  return infoTooltip ? <Tooltip title={infoTooltip}>{chip}</Tooltip> : chip;
}
